import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  private messages: BehaviorSubject<string[]>;

  constructor(private toaster: ToastrService) {
    this.messages = new BehaviorSubject<string[]>([]);

    // If no errors were added in the last 200ms, execute
    // Commented out as it trigger change detection every interval
    // this.messages.pipe(debounceTime(200)).subscribe(errors => {
    //   // For each errors, display them
    //   errors.forEach(error => this.toaster.error(error));
    //   // Remove all errors
    //   this.messages.next([]);
    // });
  }

  public addMessage(message: string): void {
    // Add error if a duplicate isn't already waiting to be displayed
    // if (this.messages.value.indexOf(message) === -1) {
    //   this.messages.next([...this.messages.value, message]);
    // }
    this.toaster.error(message);
  }
}
